import React, { useContext } from "react";
import Context from "../../Context";
import { Link } from "react-router-dom";

function Footer(props) {
  const cx = useContext(Context);
  const copyYear = new Date().getFullYear();
  return (
    <div className="footer bg-white py-4 d-flex flex-lg-column">
      <div className=" container-fluid  d-flex flex-column flex-md-row align-items-center justify-content-between">
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">
            {copyYear} &copy;
          </span>
          <a href="/" className="text-dark-75 text-hover-primary">
            Ship Safety Service
          </a>
          <span className="text-muted"> v.{cx.config.showVersion}</span>
        </div>
        <div className="nav nav-dark">
          {/*
          <Link className="nav-link pl-0 pr-5" to="/ship-safety/guide">
            {cx.t("pages.guide")}
          </Link>
          <Link className="nav-link pl-0 pr-5" to="/ship-safety/license">
            {cx.t("pages.license")}
          </Link>
          <Link className="nav-link pl-0 pr-5" to="/support">
            {cx.t("pages.support")}
          </Link>
          */}
        </div>
      </div>
    </div>
  );
}

export default Footer;
